<div class="container-fluid" style="margin-top: 15px;">
    <app-file-upload (openFile)="loadDataModule($event)" [newVersionSaved]="newVersionSaved"></app-file-upload>
    <hr class="theme-hr" />
    <app-data-module (updateFilesModule)="updateFilesModule($event)" *ngIf="showDataModule" [fileObj]="fileObj"></app-data-module>
</div>
